import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { PlanoPagto } from '../../dto/PlanoPagamento';
import { labelGrid } from '../utils';
import { Alert } from "@mui/material";

function CustomTableSelectPlanoPagamento(props: { data: any[], buscouPlanoPgto: boolean, handleSetPlanoPagamento: (planoPagamento: PlanoPagto) => void }) {
  const rows = props.data;
  const showCollsTable = ["codPlanoPagto", "descricao"];
  const StyledTableCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: '#e9f2fd',
      color: '#0f3550',
      fontSize: '12px',
      letterSpacing: '0.6px',
      padding: '4px 16px',
      marginTop: '-5px',
      borderBottom: '2px solid #d9e5ee',
      position: 'sticky' as const,
      top: 0,
      zIndex: 2,
      whiteSpace: 'nowrap' as const,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: '12px',
      color: '#334155',
      padding: '5px 16px',
      borderBottom: '1px solid #E2E8F0',
    },
  }));

  const StyledTableRow = styled(TableRow)(() => ({
    height: '32px',
    '&:nth-of-type(odd)': {
      backgroundColor: '#f8fafc',
    },
    '&:hover': {
      backgroundColor: '#eef4fb',
      transition: 'background-color 0.15s ease',
    },
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));

  return (
    <>
      <Alert severity="info" sx={{
        mb: 1,
        py: 0.5, // padding vertical menor
        px: 1.5, // padding horizontal
        fontSize: "12px",
        display: "flex",
        alignItems: "center", // garante alinhamento vertical
        backgroundColor: "#e9f2fd",
        color:'#0965c1',
        '& .MuiAlert-icon': {
          color: '#0965c1',
        },
      }}>
        Registros <span style={{ textDecoration: "line-through", opacity: 0.7, fontStyle: "italic" }}>tachados </span> e que não possuem a opção "Adicionar", estão inativos e não podem ser selecionados.
      </Alert>

      <TableContainer
        component={Paper}
        sx={{
          height: '100%',
          maxHeight: '100%',
          overflowY: 'auto',
          overflowX: 'auto',
          boxShadow: 'none',
          borderRadius: '4px',
          border: '1px solid #e2e8f0',
        }}
      >
        <Table aria-label="customized table" stickyHeader>
          <TableHead>
            <TableRow>
              <StyledTableCell sx={{ width: 100, whiteSpace: 'nowrap', textAlign: 'left !important' }}>{labelGrid.cod}</StyledTableCell>
              <StyledTableCell sx={{ textAlign: 'left !important' }}>{labelGrid.descricao}</StyledTableCell>
              <StyledTableCell sx={{ width: 96, textAlign: 'center !important' }}>{labelGrid.opcoes}</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows && rows.length > 0 ? (
              rows.map((row: any, index: number) => {
                const isAtivo = (row.ativo ?? 'S') === 'S';

                return (
                  <StyledTableRow
                    key={index}
                    sx={{
                      textDecoration: isAtivo ? 'none' : 'line-through',
                      opacity: isAtivo ? 1 : 0.55,
                      fontStyle: isAtivo ? 'normal' : 'italic',
                    }}
                  >
                    {showCollsTable.map((col) => (
                      <TableCell key={col} align="left" sx={{ fontSize: '12px', color: '#334155', padding: '5px 16px', borderBottom: '1px solid #E2E8F0' }}>
                        {row[col] !== undefined && row[col] !== null && row[col] !== ''
                          ? row[col]
                          : <span style={{ color: '#94a3b8', fontSize: '12px' }}>N/D</span>}
                      </TableCell>
                    ))}
                    <TableCell align="center" sx={{ width: 96, padding: '2px 8px', borderBottom: '1px solid #E2E8F0' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5, width: '100%' }}>
                        {isAtivo ? (
                          <Tooltip title="Adicionar">
                            <IconButton
                              onClick={() => props.handleSetPlanoPagamento(row)}
                              size="small"
                              sx={{ color: '#0965c1', '&:hover': { color: '#1D4ED8', backgroundColor: 'rgba(37,99,235,0.08)' } }}
                            >
                              <AddCircleIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        ) : null}
                      </Box>
                    </TableCell>
                  </StyledTableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={showCollsTable.length + 1} align="center" sx={{ py: 6, borderBottom: 0 }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                    <SearchOffIcon sx={{ fontSize: 36, color: '#94a3b8' }} />
                    <Typography sx={{ fontSize: '14px', color: '#64748b', fontWeight: 500 }}>
                      Nenhum plano de pagamento encontrado
                    </Typography>
                    <Typography sx={{ fontSize: '12px', color: '#94a3b8' }}>
                      Tente ajustar os filtros de busca
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default CustomTableSelectPlanoPagamento;
